var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container",attrs:{"id":"app"}},[_c('div',{staticClass:"container d-flex justify-content-between align-items-start flex-wrap xl-gap"},[_c('div',{staticClass:"col-12 pe-xl-4 py-4"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }